import PropTypes from "prop-types";
import { useState } from "react";
import ImageGalleryContainer from "./ImageGalleryContainer";

const ImageGalleryWithoutPreview = ({
  additionalImageUrls,
  className,
  imageUrl,
  onLoad,
  onTransitionEnd
}) => {
  const [showPlaceholder, setShowPlaceholder] = useState(true);

  return (
    <ImageGalleryContainer
      onTouchStart={() => setShowPlaceholder(false)}
      onTouchImages={additionalImageUrls}
      primaryImageProps={{
        imageUrl,
        className,
        onLoad,
        onTransitionEnd
      }}
    >
      {showPlaceholder && <div />}
    </ImageGalleryContainer>
  );
};

ImageGalleryWithoutPreview.propTypes = {
  additionalImageUrls: PropTypes.arrayOf(PropTypes.string).isRequired,
  className: PropTypes.string,
  imageUrl: PropTypes.string.isRequired,
  onLoad: PropTypes.func,
  onTransitionEnd: PropTypes.func
};

export default ImageGalleryWithoutPreview;
